import React, { MutableRefObject, createContext, useContext, useRef } from 'react';
import { makeLog } from 'shared/utils/log';
import { OutboundSession } from './OutboundSession';
import { OutboundTranscriber } from './OutboundTranscriber';

const log = makeLog('OutboundContext');

export const OutboundContext = createContext<{
  session: MutableRefObject<OutboundSession>;
  transcriber: MutableRefObject<OutboundTranscriber>;
  pristineMp3: MutableRefObject<HTMLAudioElement>;
}>({
  // HACK: It looks like there's no way to not provide a default, but we
  // want to try as hard as possible to ensure that there's a singleton
  // session for the whole time the agent interacts with the app.
  session: { current: undefined as any },
  transcriber: { current: undefined as any },
  pristineMp3: { current: undefined as any },
});

export const useOutboundContext = () => {
  return useContext(OutboundContext);
};

export const OutboundProvider: React.FC = ({ children }) => {
  const session = useRef<OutboundSession>(null);
  if (session.current === null) {
    log.debug('Creating OutboundSession.');
    (session as any).current = new OutboundSession();
  }
  const transcriber = useRef<OutboundTranscriber>(null);
  if (transcriber.current === null) {
    log.debug('Creating OutboundTranscriber.');
    (transcriber as any).current = new OutboundTranscriber();
  }
  const pristineMp3 = useRef<HTMLAudioElement>(null);
  if (pristineMp3.current === null) {
    log.debug('Creating pristine.mp3.');
    (pristineMp3 as any).current = new Audio(
      'https://assets.servicebell.com/pristine.mp3',
    );
  }
  return (
    <OutboundContext.Provider
      value={{
        session: session as MutableRefObject<OutboundSession>,
        transcriber: transcriber as MutableRefObject<OutboundTranscriber>,
        pristineMp3: pristineMp3 as MutableRefObject<HTMLAudioElement>,
      }}
    >
      {children}
    </OutboundContext.Provider>
  );
};
